import React from 'react';

import XRemove from './assets/x-remove.svg';

export const Remove = () => (
  <img src={XRemove} alt="SVG Icon" />
);
